import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import ProjectCard from 'components/project/project_card';
import taskPropTypes from 'components/tasks/prop_types';
import ContactPanelRow from 'components/contacts/contact_panel_row';
import AssignmentPropTypes from '../assignment_prop_types';
import { ProjectPropTypes } from 'components/project/prop_types';
import ListingQuickUpdateModal from 'components/listing/quick_update/modal';
import ContactList from 'components/project/contacts_list';
import ContactSelector from 'components/project/contact_selector';
import PanelNotice from 'components/project/panel_notice';
import PredictionsCard from '../../project/components/predictions_card';
import OpenTasks from '../../project/components/open_tasks';
import ActivityFeed from '../../project/components/activity_feed';

import { updateListing, addContact, removeContact, updateContactRole } from 'components/project/actions';
import { showLogTaskModal } from '../../project/actions/index';
import PageHeader from 'components/project/page_header';
import HelpCenterLink from 'components/help_center_link';

export class AssignmentOverview extends React.Component {
  static propTypes = {
    ...AssignmentPropTypes,
    addContact: PropTypes.func.isRequired,
    editPath: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
      projectTasksActivities: PropTypes.bool
    }).isRequired,
    helpCenterUrl: PropTypes.string,
    project: ProjectPropTypes,
    removeContact: PropTypes.func.isRequired,
    showLogTaskModal: PropTypes.func.isRequired,
    showNewNoteModal: PropTypes.func.isRequired,
    showNewTaskModal: PropTypes.func.isRequired,
    tasks: PropTypes.arrayOf(taskPropTypes),
    updateContactRole: PropTypes.func.isRequired,
    updateListing: PropTypes.func.isRequired,
  };

  state = {
    selectedContactRole: null,
    showContactEditModal: false,
    showListingEditModal: false
  };

  showListingEditModal = () => {
    this.setState({ showListingEditModal: true });
  };

  handleListingUpdate = (listing) => {
    this.hideListingEditModal();
    this.props.updateListing(listing);
  };

  hideListingEditModal = () => {
    this.setState({ showListingEditModal: false });
  };

  showContactEditModal = (e, selectedContactRole = null) => {
    if (e) e.preventDefault();

    this.setState({ showContactEditModal: true, selectedContactRole });
  };

  hideContactEditModal = () => {
    this.setState({ showContactEditModal: false, selectedContactRole: null });
  };

  addContact = (contact) => {
    this.props.addContact(
      this.props.project.id,
      contact.associatedModelId,
      contact.associatedModelType,
      contact.relation
    ).then(this.hideContactEditModal);
  }

  updateContact = (contact) => {
    this.props.updateContactRole(
      this.props.project.id,
      this.state.selectedContactRole.id,
      contact.relation
    ).then(this.hideContactEditModal);
  }

  removeContact = (contactRoleId) => {
    this.props.removeContact(this.props.project.id, contactRoleId);
  }

  render() {
    const { contacts, databases, listing } = this.props.project;
    const { assignment, features, showLogTaskModal, showNewTaskModal } = this.props;
    const { selectedContactRole } = this.state;

    if (!features.projectTasksActivities) {
      return (
        <PanelNotice name="no-access-message">
          <h4>You must be a collaborator on this assignment to access the Workspace.</h4>
        </PanelNotice>
      );
    }
    const overviewCardAction = (
      <a href="#" name="add-note" onClick={this.showContactEditModal}>
        <FontAwesomeIcon icon={faPlus} size="sm"/> Contact
      </a>
    );

    const headerActions = (
      <PageHeader.Actions>
        <HelpCenterLink helpCenterUrl={this.props.helpCenterUrl} linkText="Learn more about Projects"/>
      </PageHeader.Actions>
    );

    return (
      <div>
        <PageHeader actions={headerActions} title="Project Overview" />
        <Row>
          <Col className="project-col" md={features.projectTasksActivities ? 4 : 12}>
            <ProjectCard
              className="dynamic-height overview-panel position-relative"
              name="Details"
              rightActions={[overviewCardAction]}
            >
              {assignment.client && <ContactPanelRow contact={assignment.client} name="client-row" />}
              <ContactList
                contacts={contacts}
                showLogTaskModal={showLogTaskModal}
                showNewTaskModal={showNewTaskModal}
                onAddContactClicked={!databases && !features.crm ? this.showContactEditModal : null}
                onRemoveContact={this.removeContact}
              />
            </ProjectCard>
            <PredictionsCard
              editLink={this.props.editPath}
              features={features}
              listing={listing}
              showModal={this.showListingEditModal}
            />
          </Col>
          {features.projectTasksActivities &&
            <Col className="project-col-2x project-overview-col" md={8}>
              <OpenTasks showNewTaskModal={showNewTaskModal}/>
              <ActivityFeed limitView linkToActivitiesTab={true} />
            </Col>
          }
        </Row>

        {listing &&
          <ListingQuickUpdateModal
            features={features}
            listing={listing}
            show={this.state.showListingEditModal}
            onCancel={this.hideListingEditModal}
            onSave={this.handleListingUpdate}
          />
        }

        <ContactSelector
          selectedContactRole={selectedContactRole}
          show={this.state.showContactEditModal}
          onCancel={this.hideContactEditModal}
          onSave={selectedContactRole ? this.updateContact : this.addContact}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ assignment, features, project }) => ({
  assignment,
  features,
  project
});

export default connect(
  mapStateToProps,
  {
    addContact,
    removeContact,
    showLogTaskModal,
    updateListing,
    updateContactRole
  }
)(AssignmentOverview);
